import styled, { createGlobalStyle } from "styled-components";

export const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  border: none;
  background: transparent;
  padding: 0;
  margin-left: 0.35rem;
  line-height: 0;
  color: #b9b9c3;
  cursor: pointer;

  &:hover {
    color: #6e6b7b;
  }
`;

// Popover do reactstrap renderiza em portal; estilizamos pela className.
export const PopoverStyle = createGlobalStyle`
  .info-popover {
    max-width: 380px;
  }

  .info-popover .info-popover-body {
    max-height: 320px;
    overflow-y: auto;
    text-align: left;
    font-size: 0.85rem;
    line-height: 1.35;
  }

  .info-popover .info-popover-body p:last-child {
    margin-bottom: 0;
  }

  .info-popover .info-popover-body ul {
    padding-left: 1rem;
    margin-bottom: 0;
  }
`;
